import "./RequiredSymbol.less";

const RequiredSymbol = (): JSX.Element => {
    return <span className="required-symbol">* </span>;
};

export default RequiredSymbol;
